export const Roles = {
  ADMIN_ECBR: 'ADMIN_ECBR',
  VIEWER_ECBR: 'VIEWER_ECBR',
  ADMIN_USER: 'ADMIN_USER',
  VIEWER_USER: 'VIEWER_USER',
  PILLAR_OWNER: 'PILLAR_OWNER'
}

export const AdminRoles = [Roles.ADMIN_ECBR, Roles.VIEWER_ECBR]

export const UserRoles = [
  Roles.ADMIN_USER,
  Roles.VIEWER_USER,
  Roles.PILLAR_OWNER
]

export const ecbrAdminRoleListForSelect = [
  { value: Roles.ADMIN_ECBR, label: 'Administrador ECBR' },
  { value: Roles.VIEWER_ECBR, label: 'Visualizador ECBR' }
]

export const ecbrUserRoleListForSelect = [
  { value: Roles.ADMIN_USER, label: 'Administrador' },
  { value: Roles.VIEWER_USER, label: 'Visualizador' },
  { value: Roles.PILLAR_OWNER, label: 'Responsável de Pilar' }
]

export const roleListForSelect = [
  ...ecbrAdminRoleListForSelect,
  ...ecbrUserRoleListForSelect
]
